var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page__title"},[_c('img',{staticClass:"mr-2",staticStyle:{"max-height":"10%"},attrs:{"src":require("@/assets/icons/api_key.svg")}}),_c('h1',[_vm._v(_vm._s(_vm.$t((_vm.namespace + ".pageTitle"))))])])}
var staticRenderFns = []

export { render, staticRenderFns }